"use client";

import { Box, Button, Flex, Text, Title } from "@mantine/core";
import Link from "next/link";

// const HERO_TITLE =
//   "Search 200,000+ In-Stock Disc Golf Discs from 50+ Retailers in Seconds";
// const HERO_SUBTITLE =
//   "The Ultimate Disc Golf Search Engine & Price Comparison Platform";
// const HERO_TEXT_1 =
//   "Stop wasting time searching individual disc golf shops. Stacks on Stacks instantly searches all major disc golf retailers in one place, showing you exactly what's in stock right now. Find your perfect putter, midrange, fairway driver, or distance driver using advanced filters for brand, mold, plastic type, weight, color, price, and PDGA-approved flight numbers (speed, glide, turn, fade). Compare prices, apply automatic discount codes, and get the best deals on disc golf discs—all without leaving our site.";
// const HERO_TEXT_2 =
//   "Whether you're hunting for rare limited editions, specific weights in premium plastic, or just need to complete your disc golf bag fast, we make disc golf shopping actually enjoyable. Precise results. Zero hassle.";

const HERO_TITLE = "      Stacks on Stacks Is No Longer Available";
const HERO_SUBTITLE =
  "Thank you for your support over the years. The service has officially been discontinued. Building this project and serving the disc golf community has been incredibly rewarding. Thanks for being a part of it.";
const HERO_TEXT_1 = "";
const HERO_TEXT_2 = "";

export default function Hero() {
  return (
    <Box
      style={{ position: "relative", overflow: "hidden", minHeight: "600px" }}
    >
      <picture>
        <source
          srcSet="/images/mobile_hero.webp"
          media="(max-width: 768px)"
          type="image/webp"
        />
        <img
          src="/images/hero.webp"
          alt="Collection of disc golf discs arranged in a grid showcasing various brands and colors"
          width={1200}
          height={600}
          fetchPriority="high"
          loading="eager"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: 0,
          }}
        />
      </picture>
      <Box style={{ position: "relative", zIndex: 1 }}>
        <Flex
          pt={{ base: "100px", md: "200px" }}
          px={{ base: "8px", md: "50px" }}
          pb={{ base: "50px", md: "100px" }}
          justify={{ base: "center", md: "flex-start" }}
          align={{ base: "center", md: "flex-start" }}
          direction="column"
        >
          <Title
            order={1}
            fz={{ base: "2em", sm: "4em" }}
            ta={{ base: "center", md: "left" }}
            lh={{ base: 1.2, md: undefined }}
          >
            {HERO_TITLE}
          </Title>
          <Title
            order={2}
            fz={{ base: "1.5em", sm: "2em" }}
            mt="10px"
            fw={500}
            ta={{ base: "center", md: "left" }}
          >
            {HERO_SUBTITLE}
          </Title>
          <Text
            w={{ base: "100%", md: "75%" }}
            px={{ base: "25px", md: "0" }}
            mt="20px"
            fz={{ base: "16px", md: "1.5rem" }}
            style={{ lineHeight: 1.4 }}
            ta={{ base: "center", md: "left" }}
          >
            {HERO_TEXT_1}
          </Text>
          <Text
            w={{ base: "100%", md: "75%" }}
            px={{ base: "25px", md: "0" }}
            mt="15px"
            fz={{ base: "15px", md: "1.3rem" }}
            style={{ lineHeight: 1.4 }}
            ta={{ base: "center", md: "left" }}
          >
            {HERO_TEXT_2}
          </Text>
          {/*<Link href="/disc-search" prefetch={false}>*/}
          {/*  <Button*/}
          {/*    size="lg"*/}
          {/*    w="300px"*/}
          {/*    mr={{ base: "0", md: "100px" }}*/}
          {/*    mt="50px"*/}
          {/*    variant="filled"*/}
          {/*    color="var(--colors-bg-brand)"*/}
          {/*    radius="xl"*/}
          {/*  >*/}
          {/*    <Title>Get Started</Title>*/}
          {/*  </Button>*/}
          {/*</Link>*/}
        </Flex>
      </Box>
    </Box>
  );
}
